import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteVTIconProps {
  size?: number;
  color?: string;
}

const ConcreteVTIcon: React.FC<ConcreteVTIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretevt">
    {
      <path d="M10.978 18.381h1.223l0.902-11.379h7.728v-1.382h-17.663v1.375l6.743 0.065 1.066 11.321z"></path>
    }  </SvgIcon>
);

export default ConcreteVTIcon;
